import React, { useState } from 'react'
import dynamic from 'next/dynamic'
import { Constants } from '../../../adapters/helpers/Constants';
const RichText = dynamic(() => import('../../RichText/RichText'))

export default function PdpShowMoreAccordion({ productHighlights }) {
    const highlightList = productHighlights
        ? Object.keys(productHighlights).map((key) => {
              return (
                  <li key={key} className={`ob-product-highlights__highlights-list-item ob-hyperlink-highlights-li `}>
                      <RichText document={productHighlights[key]} />
                  </li>
              )
          })
        : []

    const [mobileShowMore, setMobileShowMore] = useState(false)
    return (
        <div>
            <button
                onClick={() => {
                    setMobileShowMore(!mobileShowMore)
                }}
            >
                <span>{Constants.moreInfomation}</span>
                <img src={mobileShowMore ? Constants.upIconPath : Constants.downIconPath} alt='chevron-down'></img>
            </button>
            {mobileShowMore && <ul>{highlightList}</ul>}
        </div>
    )
}
